module.exports = __webpack_public_path__ + "img/InicioHion-sm.efaeb6a3.jpg";